export function useVATNumber() {
    /**
     * @param {string} country - Code pays ISO (FR, GP, MQ, RE, etc.)
     * @param {string} siren - Numéro SIREN (9 caractères)
     * @returns {string|null} - Numéro de TVA ou null si SIREN invalide
     */
    const generateVATNumber = (country, siren) => {
        if (!siren || siren.length !== 9) {
            return null;
        }

        let vatCountry = country;
        if (['GP', 'MQ', 'RE'].includes(country)) {
            vatCountry = 'FR';
        }

        const key = (12 + 3 * (parseInt(siren, 10) % 97)) % 97;
        const paddedKey = String(key).padStart(2, '0');

        return vatCountry + paddedKey + siren;
    };

    return {
        generateVATNumber,
    };
}
